<template>

  <EditLiteralEditor></EditLiteralEditor>
</template>


<style type="text/css">

   

</style>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

import EditLiteralEditor from "@/components/EditLiteralEditor.vue";





export default {
  name: "EditLiteralEditorTester",
  components: {
    EditLiteralEditor
    
  }

  
};
</script>
